export enum ImagePosition {
    FRONT = 'front',
    BACK = 'back',
}